export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD8O2DQ8WxCXmcYOTa2FC7j5fLLCuclvKY",
  authDomain: "proyecto-pragma-1-0.firebaseapp.com",
  projectId: "proyecto-pragma-1-0",
  storageBucket: "proyecto-pragma-1-0.firebasestorage.app",
  messagingSenderId: "1037426370620",
  appId: "1:1037426370620:web:143aadb7aaabe5f810bb39",
  measurementId: "G-Q5PBEB4MKE"
  }
  ,
  // Configuración opcional para FRED (fallback de % del PIB)
  fredApiKey: "385b9733e12464ad5f7d33ecee11f00d",
  fredSeriesId: "IDSGAMRIAOAR" // Valores de deuda internacionales del gobierno general (M USD, BIS/FRED, trimestral)
  ,
  // Configuración opcional para INDEC (series de tiempo oficiales)
  indecSeriesId: "161.1_TL_DEUDRNA_0_0_19", // Serie INDEC: Total deuda externa (M USD), trimestral
  indecCsvUrl: "https://infra.datos.gob.ar/catalog/sspm/dataset/161/distribution/161.1/download/estimacion-deuda-externa-bruta-por-sector-residente-saldos-fin-periodo-millones-dolares.csv"
  
};
